import React from "react";
import { FaBottleWater, FaBurger, FaDrumstickBite, FaIndustry } from "react-icons/fa6";
import "../styles/AerospaceFaqSection.css";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import NaicsComplianceChecker from "../components/NaicsComplianceChecker";

function NaicsRules() {
  return (
    <>
      <LandingSection
        data={{ imageName: "about.webp", title: "NAICS Compliance Checker" }}
      />

      <div className="utah-at-a-glance-section">
        <div className="utah-at-a-glance-intro">
          <div className="utah-at-a-glance-intro-sec1">
            <h2 className="text-3xl font-bold text-gray-800 text-center mt-6">
              NAICS Rules, Regulations, and Documents
            </h2>
          </div>
          <div className="utah-at-a-glance-intro-sec2">
            <p>
              Enter a 6-digit U.S. food-industry NAICS code to view applicable
              rules, regulations, permits, required documents, and actionable
              next steps.
            </p>
          </div>
        </div>
      </div>

      <div className="p-4 md:p-6 mt-10 lg:mt-14 max-w-[76rem] mx-auto">
        <div className="mb-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
          <div className="bg-white border border-slate-200 rounded-xl px-3 py-3 flex items-center gap-2">
            <FaBurger className="text-blue-600" />
            <div className="text-sm text-slate-700">
              <strong>722***</strong> Food Service
            </div>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl px-3 py-3 flex items-center gap-2">
            <FaIndustry className="text-blue-600" />
            <div className="text-sm text-slate-700">
              <strong>311***</strong> Manufacturing
            </div>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl px-3 py-3 flex items-center gap-2">
            <FaDrumstickBite className="text-blue-600" />
            <div className="text-sm text-slate-700">
              <strong>311611</strong> Meat / USDA Rule
            </div>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl px-3 py-3 flex items-center gap-2">
            <FaBottleWater className="text-blue-600" />
            <div className="text-sm text-slate-700">
              <strong>312***</strong> Beverage
            </div>
          </div>
        </div>

        <div className="w-full">
          <NaicsComplianceChecker />
        </div>
      </div>

      <Footer />
    </>
  );
}

export default NaicsRules;
